import { makeStyles } from '@mui/styles';

// colors
import { colors } from '../../../../colors';

export const useStyles = makeStyles({
  wrapper: props => ({
    display: 'flex',
    flexDirection: 'column',
    width: props.expanded ? '300px' : '100px',
    minWidth: props.expanded ? '300px' : '100px',
    borderRight: `1px solid ${colors.neutral100}`,
    backgroundColor: colors.neutral25,
    transition: 'width 0.4s ease-in-out',
  }),
  collapseArea: props => ({
    padding: '20px 36px',
  }),
  collapseButton: {
    display: 'flex',
    cursor: 'pointer',
  },
  stepsContainer: {
    flex: 1,
    overflowY: 'auto',
  },
  mainSection: props => ({
    padding: '8px 12px',
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'row',
    gap: '8px',
    cursor: 'pointer',
    justifyContent: props.expanded ? 'flex-start' : 'center',
    borderRadius: '6px',
    margin: '4px 24px',
    '&:hover': {
      backgroundColor: colors.primary100,
    },
  }),
  mainSectionSelected: {
    backgroundColor: colors.primary100,
  },
  disabled: {
    opacity: 0.5,
    cursor: 'not-allowed !important',
    pointerEvents: 'none',
  },
  subsection: props => ({
    padding: props.expanded ? '10px 0px 10px 44px' : '8px 12px',
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'row',
    gap: '8px',
    cursor: 'pointer',
    justifyContent: props.expanded ? 'flex-start' : 'center',
    borderRadius: '6px',
    margin: '4px 24px',
    fontSize: '14px',
    color: colors.neutral700,
    fontFamily: 'Manrope',
    fontWeight: 400,
    lineHeight: '20px',
    userSelect: 'none',
    '&:hover': {
      backgroundColor: colors.primary50,
    },
  }),
  dctName: ({ expanded }) => ({
    padding: expanded ? '8px 24px 8px 68px' : '8px 24px',
    textAlign: expanded ? 'left' : 'center',
    margin: 0,
    color: colors.neutral700,
    fontFamily: 'Manrope',
    fontSize: '14px',
    fontWeight: 500,
    lineHeight: '20px',
    cursor: 'pointer',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
  }),
  subsectionSelected: {
    backgroundColor: colors.primary50,
    fontWeight: '600 !important',
    color: `${colors.primary600} !important`,
  },
  sectionCount: {
    color: colors.neutral500,
    textAlign: 'center',
    fontSize: '12px',
    borderRadius: '50%',
    border: `1px solid ${colors.neutral300}`,
    fontWeight: 600,
    lineHeight: '16px',
    height: '24px',
    width: '24px',
    minWidth: '24px',
    minHeight: '24px',
    alignContent: 'center',
    display: 'inline-block',
    userSelect: 'none',
  },
  sectionSelected: {
    border: `1px solid ${colors.primary500}`,
    color: colors.primary500,
    backgroundColor: colors.white,
    fontWeight: 700,
  },
  sectionCompleted: {
    border: `1px solid ${colors.success500}`,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    '& svg': {
      width: '16px !important',
      height: '16px !important',
    },
    '& svg path': {
      fill: `${colors.success500} !important`,
    },
  },
  sectionTitle: ({ expanded }) => ({
    color: colors.neutral700,
    fontFamily: 'Manrope',
    fontSize: '14px',
    fontWeight: 600,
    lineHeight: '20px',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    opacity: expanded ? 1 : 0,
    transition: 'opacity 0.2s ease-in-out',
  }),
  sectionTitleSelected: {
    color: `${colors.primary500} !important`,
    fontWeight: '700 !important',
  },
  memberActionsWrapper: props => ({
    padding: `24px 16px`,
    display: 'flex',
    flexDirection: props.expanded ? 'row' : 'column',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '16px',
  }),
  actionBtn: {
    padding: 0,
    borderRadius: '4px',
    minWidth: '40px !important',
    width: '40px !important',
    height: '40px !important',
    '& svg': {
      width: '16px',
      height: '16px',
    },
  },
  profileBtn: {
    border: `1px solid ${colors.primary500}`,
    color: colors.primary500,
    '& svg': {
      '& path': {
        fill: colors.primary500,
      },
    },
    '&:hover': {
      backgroundColor: colors.primary100,
    },
  },
  amaBtn: {
    border: `1px solid ${colors.secondary500}`,
    color: colors.secondary500,
    '& svg': {
      '& path': {
        fill: colors.secondary500,
      },
    },
    '&:hover': {
      backgroundColor: colors.secondary100,
    },
  },
  apptBtn: {
    border: `1px solid ${colors.green500}`,
    color: colors.green500,
    '& svg': {
      '& path': {
        fill: colors.green500,
      },
    },
    '&:hover': {
      backgroundColor: colors.green50,
    },
  },
  chatBtn: {
    border: `1px solid ${colors.orange500}`,
    color: colors.warning500,
    '& svg': {
      '& path': {
        fill: colors.warning500,
      },
    },

    '&:hover': {
      backgroundColor: colors.warning100,
    },
  },
  evaluationContainer: {
    display: 'flex',
    flexDirection: 'column',
  },
});
